import React, { useMemo, useEffect } from 'react';
import Presentations from './presentations/Presentations';
import PresentationsWithSections from './presentationsWithSections/PresentationsWithSections';
// import { ContentType } from '../../../../types';
import styles from './SidebarUnit.module.scss';
import { ExtendedUnitFragment, LessonType as TeacherLessonType,
  Content, LastVisitedLessonContentFragment, Section } from '@api/graphql-codegen';
import { useCourseContent } from '@hooks/useCourseContent';
import { Lesson } from '@types';
import { sortByPosition } from '@utils/helpers';
import { logger } from '../../../../utils/logger';

interface SidebarUnitProps {
  unit: ExtendedUnitFragment;
  lesson: Lesson;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  isParentApp?: boolean;
  closeNav?: () => void;
  startLesson: (lesson: Lesson) => void;
  startExercise?: (exercise: Section) => void;
}

const SidebarUnit = ({ unit, lesson, closeNav, startLesson, startExercise }: SidebarUnitProps) => {

  const { setCurrentUnit, setContent, content, setLesson } = useCourseContent();

  const modules = useMemo(() => {
    return [...lesson.modules || []].filter(module => module.lastInLesson !== true).sort(sortByPosition) 
  }, [lesson.modules]);

  const sections = useMemo(() => {
    return [...lesson.sections || []]; 
  }, [lesson.sections]);

  const hasSections = useMemo(() => !!sections?.length && lesson?.alternativeActivated, [lesson?.alternativeActivated, sections?.length]);

  const listwrapper = useMemo(() => [styles.wrapper, styles.opened].join(' '), []);

  useEffect(() => {
    if (lesson) {
      setLesson(lesson)
    }
    if (unit) {
      setCurrentUnit(unit)
    }
  }, [lesson, setLesson, unit, setCurrentUnit])
  useEffect(() => {
    if (modules.length > 0 && !content) {
      logger.info('Setting Content =====')
      setContent(modules.at(0) as any)  
    }
  }, [content, modules, setContent])

  return (
    <div className={listwrapper}>
      <section className={styles.list}>
        {hasSections ? (
          <PresentationsWithSections
            lessonOpened={true}
            lessonType={TeacherLessonType.PRESENTATION}
            lesson={lesson}
            contents={modules as Content[]}
            sections={sections}
            closeNav={closeNav}
            startLesson={startLesson}
            startExercise={startExercise}
          />
        ) : (
          <Presentations
            lessonOpened={true}
            lessonType={TeacherLessonType.PRESENTATION}
            lesson={lesson}
            contents={modules as Content[]}
            closeNav={closeNav}
          />
        )}
        
      </section>
    </div>
  )
}

export default SidebarUnit;
